export const UPDATE_CATEGORY = 'news/UPDATE_CATEGORY'
export const UPDATE_NEWS = 'news/UPDATE_NEWS'
export const UPDATE_ACTIVITIES = 'news/UPDATE_ACTIVITIES'
export const UPDATE_MEDIAS = 'news/UPDATE_MEDIAS'
export const UPDATE_CURRENT_MEDIA = 'news/UPDATE_CURRENT_MEDIA'
export const UPDATE_CURRENT_NEWS = 'news/UPDATE_CURRENT_NEWS'


